import React, { useEffect, useState } from "react";
import { IonBackButton, IonButton, IonText, useIonAlert } from "@ionic/react";
import {
	IonInput,
	IonItem,
	IonLabel,
	IonSelect,
	IonSelectOption,
	IonButtons,
	IonContent,
	IonHeader,
	IonMenuButton,
	IonPage,
	IonTitle,
	IonToolbar,
	IonCol,
	IonGrid,
	IonRow,
	IonIcon
} from "@ionic/react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Phone } from "../../controls";
import { add, arrowBackOutline } from "ionicons/icons";
import useStore from "../../store/store";
import BackButton from "../../components/BackButton";
import moment from "moment";
import AnimatedPage from "../AnimatedPage";
import validator from "validator";

const NewTenant: React.FC = () => {
	const { t } = useTranslation();
	const history = useHistory();
	let [name, setName] = useState<string>("");
	let [email, setEmail] = useState<string>("");
	let [phone, setPhone] = useState<string>("");
	let [error, setError] = useState<string>("");
	let [toEditId, setToEditId] = useState<string>("");
	let [msg, setMsg] = useState<string>("");
	let [isDisabled, setIsDisabled] = useState<boolean>(false);
	const { setIsLoading, token } = useStore((state: any) => state);

	useEffect(() => {
		if (window.location.href.includes("id=")) {
			let id = window.location.href.split("id=").pop();
			if (id) {
				setToEditId(id);
				axios
					.get(`${process.env.REACT_APP_API_URL}/tenants/${id}`)
					.then(res => {
						setName(res.data.name);
						setEmail(res.data.email);
						setPhone(res.data.phone);
					})
					.catch(err => {
						setError(`${err.response.data}`);
					});
			}
		} else return;
	}, []);

	const submitData = () => {
		if (name === "") {
			setError(t("requiredName") || "");
			return;
		}
		if (phone === "") {
			setError(t("requiredPhone") || "");
			return;
		}

		if (email !== "") {
			if (!validator.isEmail(email)) {
				setError(t("validEmail") || "");
				return;
			}
		}

		setIsLoading(true);
		setIsDisabled(true);
		let obj = { name, email, phone, joined: moment().format() };

		if (toEditId === "") {
			axios
				.post(`${process.env.REACT_APP_API_URL}/tenants/`, obj, {
					headers: { rentapp_auth: token }
				})
				.then(res => {
					setMsg(t("tenantSaved") || "");
					clearForm();
					setIsLoading(false);
					setIsDisabled(false);
					history.push(`/tenants`);
				})
				.catch(err => {
					setError(`${err.response.data}`);
					setIsLoading(false);
					setIsDisabled(false);
				});
		} else {
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/tenants/${toEditId}`,
					obj,
					{
						headers: { rentapp_auth: token }
					}
				)
				.then(res => {
					setMsg(t("tenantUpdated") || "");
					setToEditId("");
					clearForm();
					setIsLoading(false);
					setIsDisabled(false);
					history.push(`/tenants`);
				})
				.catch(err => {
					setError(`${err.response.data}`);
					setIsLoading(false);
					setIsDisabled(false);
				});
		}
	};

	const clearForm = () => {
		setName("");
		setEmail("");
		setPhone("");
	};

	return (
		<IonPage>
			<AnimatedPage>
				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonMenuButton />
						</IonButtons>
						<IonTitle>{t("newTenant")}</IonTitle>
					</IonToolbar>
				</IonHeader>

				<IonContent fullscreen>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonButtons slot="start">
								<IonBackButton
									text=""
									defaultHref="/tenants"
									icon={arrowBackOutline}
									style={{ marginLeft: 10 }}
								/>
							</IonButtons>
							<IonTitle size="large" style={{ marginLeft: 40 }}>
								{t("newTenant")}
							</IonTitle>
						</IonToolbar>
					</IonHeader>
					<IonGrid>
						<IonRow>
							<IonCol size="12">
								<IonItem>
									<IonLabel position="floating">
										{t("name")}
									</IonLabel>
									<IonInput
										placeholder={t("name") || ""}
										value={name}
										onIonInput={(e: any) =>
											setName(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol size="12">
								<IonItem>
									<IonLabel position="floating">
										{t("email")}
									</IonLabel>
									<IonInput
										placeholder={t("email") || ""}
										value={email}
										onIonInput={(e: any) =>
											setEmail(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol size="12" style={{ marginTop: 20 }}>
								<Phone
									label={t("phone")}
									value={phone}
									onChange={setPhone}
									labelPosition="fixed"
								/>
							</IonCol>
							<IonCol size="12" style={{ marginTop: 20 }}>
								<Button
									text={t("addTenant")}
									onClick={submitData}
									icon={add}
									disabled={isDisabled}
								></Button>
							</IonCol>
							<IonCol size="12">
								<IonText color="danger">{error}</IonText>
								<IonText color="success">{msg}</IonText>
							</IonCol>
						</IonRow>
					</IonGrid>
				</IonContent>
			</AnimatedPage>
		</IonPage>
	);
};

export default NewTenant;
